export default __webpack_public_path__ + "static/media/promos-banner-ms.09498d29.webp";